export default __webpack_public_path__ + "static/media/mobile_calendar.a2bec7f0.svg";